import React, { useState, useEffect } from 'react';
import { getDashboardStats } from '../../services/dashboard';

const PaymentMethodIntentionCard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const response = await getDashboardStats();
      if (response && response.success !== false && response.data) {
        setData(response.data.paymentMethodIntention || null);
      }
    } catch (error) {
      console.error('Failed to load payment method intention stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 animate-pulse">
        <div className="h-16 bg-gray-200 rounded" />
      </div>
    );
  }

  if (!data || (data.totalWithIntention === 0 && !data.percentageCreditCard && !data.percentageBankTransfer)) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Payment method intention</h3>
        <p className="text-sm text-gray-500">No invoice payment intentions recorded yet.</p>
      </div>
    );
  }

  const pctCard = data.percentageCreditCard ?? 0;
  const pctBank = data.percentageBankTransfer ?? 0;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">Payment method intention</h3>
      <p className="text-xs text-gray-500 mb-4">
        Based on {data.totalWithIntention || 0} invoice{data.totalWithIntention !== 1 ? 's' : ''} with intention set
      </p>
      <div className="flex flex-wrap gap-8 items-center">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-emerald-50 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="1.5">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
              <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{pctCard}%</p>
            <p className="text-xs font-medium text-gray-500">Credit card</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="1.5">
              <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
              <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
              <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z" />
            </svg>
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{pctBank}%</p>
            <p className="text-xs font-medium text-gray-500">Bank transfer</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodIntentionCard;
